import React, { useState } from 'react';
import { useForm } from '@formspree/react';
import Swal from 'sweetalert2';
import '../CSS/ContactUs.css';
import Logo from "../Images/Ambassador.png";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone:'',
    message: ''
  });

  const [state, handleSubmit] = useForm("xgvealgr");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };



  const handleFormSubmit = async (e) => {
    const loadingAlert = Swal.fire({
          // title: "Loading",
          text: "Please wait...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false
        });
  
        Swal.showLoading();
  
    
    e.preventDefault();
    await handleSubmit(e);
  };

  if (state.succeeded) {
    Swal.fire({icon:"success",showConfirmButton:false,timer:2000})
    return (
      <div className='FormSubmitUiWrap'>
        <div className='FormSubmitUi' style={{ width: '100%', height: "100vh" }}>
          <img src={Logo} alt="Logo"/>
          <p>Your request has been submitted and one of our representatives shall surely get back to you as soon as possible. Thanks.</p>
          <button onClick={() => window.location.reload()}>Ok</button>
        </div>
      </div>
    );
  }

  return (
    <div className='ContactFormWrap'>
      <div className="contact-form-container">
        <h2>CONTACT ENGR. CHINEDU JOSEPH NDU</h2>
        <img src={Logo} alt="Logo"/>
        <form onSubmit={handleFormSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" disabled={state.submitting}>Submit</button>
        </form>
        <div className="footer-contact" style={{ textAlign: "center", alignItems: "center", color: "blue" }}>
          {/* <p>Address: Teshie Nungua Estate, <br/>
          Block 8, Plot 32-45 Ankwa Dobro,<br/>
          Nsawam Adoagyiri, Eastern Region, Ghana.<br/>
          P.O. BOX TN 155,
          </p> */}
          <p>Email: neduforad@yahoo.com</p>
          <p>Phone: +234 803 090 6974</p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
